import MarkdownIt from "markdown-it";
import markdownItUnderline from "./markdownItUnderline";

export const markdownItInstance = new MarkdownIt({ typographer: true }).use(
  markdownItUnderline,
);

export const flattenMarkdown = (markdown?: string | null) => {
  const tokens = markdownItInstance.parseInline(markdown ?? "", {});
  return tokens[0]?.children
    ?.filter(
      (t) => t.type === "inline" || t.type === "text" || t.type === "softbreak",
    )
    .map((t) => {
      return t.type === "softbreak" ? "\n" : t.content;
    })
    .join("")
    .trim();
};
